import React from 'react';
import { Duration } from 'luxon';
import { useTranslation } from 'react-i18next';

type CheckoutTimerProps = {
	timeRemaining: number;
};

export const CheckoutTimer = ({ timeRemaining }: CheckoutTimerProps) => {
	const { t } = useTranslation();
	const displayTime = timeRemaining ? Duration.fromObject({ seconds: timeRemaining }).toFormat('m:ss') : '...';

	return (
		<div className="bg-tablz-dark-gray-2 py-4 w-full flex justify-center">
			<p className="font-poppins text-tablz-light-gray-3">
				{t('checkout.holding_spot')}{' '}
				<span className="text-progress-bar-completed" aria-label='Checkout time remaining' role='timer' aria-atomic='true'>
					{displayTime}
				</span>
			</p>
		</div>
	);
};
